import { render } from "./get-user-debit.vue?vue&type=template&id=73540215&scoped=true"
import script from "./get-user-debit.vue?vue&type=script&lang=js"
export * from "./get-user-debit.vue?vue&type=script&lang=js"

import "./get-user-debit.vue?vue&type=style&index=0&id=73540215&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73540215"]])

export default __exports__